module.exports = __webpack_public_path__ + "img/business-map.a125d962.png";